<bt-loader [loaderId]="orderDetailsLoaderId">
  @if(orderDetails.data){
  <ng-container>
    <div class="flex center margin-bottom">
      <button class="icon-button back-button flex-0 margin-right-x-small" (click)="onBack()">
        <i class="fa fa-chevron-left"></i>
      </button>
      <h4 class="flex-1">Order # {{orderNumber}} - {{orderDetails.orderStatus?.statusName}}</h4>
      
      <div class="button-container">
        <button class="flex-0" (click)="getShootingList()"><i class="fa fa-download"></i>Shooting List</button>
        <button class="flex-0" (click)="onOrderComments()"><i class="fa fa-comments"></i>Order comments</button>
      </div>
    </div>

    <div class="flex">
      <div class="container-65 margin-right-small padding-right-small overflow mini custom-max-height">
        @for(item of orderDetails.dataToView; track item){
        @let key = item.styleCode + item.colorCode;

        <div class="card flex center margin-bottom-small" [ngClass]="{'show-images': sortedImages[key]}">
          <button class="icon-button margin-right-small flex-0" title="Style shots comments"
            (click)="onStyleComments(item)">
            <i class="fa fa-comments"></i>
          </button>
          <!-- <div class="flex-0 margin-right">
            <bt-menu [show]="item.showMenu"
                     (hidden)="item.showMenu = false"
                     (showed)="item.showMenu = true">
              <div class="menu-item"
                   (click)="onStyleComments(item)">
                <i class="fa fa-comments"></i>Style shots comments
              </div>
            </bt-menu>
          </div> -->
          <div class="flex-0 margin-right-small nowrap">
            <div class="padding-bottom-x-small truncate"><b>Style</b>: {{item.fullName}}</div>
            <div class="padding-bottom-x-small truncate"><b>Brand</b>: {{item.brandName}}</div>
            <div class="padding-bottom-x-small truncate"><b>Color</b>: {{item.colorCode}} - {{item.colorName}}</div>
            <div class="padding-bottom-x-small truncate"><b>Size group</b>: {{item.sizeGroupName || ' - All size groups - '}}</div>
            <div class="truncate"><b>Shots</b>: {{item.shots ? item.shots.length : '0'}}</div>
          </div>
          <div class="flex-1 margin-left-small nowrap flex center justify-end">
            <div *ngFor="let s of item.shots" class="margin-left-x-small margin-right-x-small flex column center">
              <b class="margin-bottom-x-small flex justify-center">{{s.shotTypeCode}}</b>
              <div class="flex justify-center">{{s.shotTypeName}}</div>
              <div class="flex justify-center">Media: {{s.mediaType}}</div>
              <div class="flex justify-center">Ratio: {{s.aspectRatio}}</div>
              <div class="margin-bottom-small flex justify-center">Utilizzo: {{s.codifiedUsed}}</div>
              <div class="thumbnail border"
                [ngClass]="{'empty': s.shotApprovalStateId === shotStatusEnum.NotUploaded || !s.imgPath, 'dragoverable': s.shotApprovalStateId !== shotStatusEnum.Approved, 'overed': overedData.shot && s.shotId === overedData.shot.shotId}"
                (dragover)="onDragOver($event, s, item)">
                <div class="img-container">
                  @if(s.shotApprovalStateId !== shotStatusEnum.NotUploaded && !!s.imgPath){
                    <img [preview]="s.shotTypeName" [src]="s.imgPath">

                    <div (click)="onShowShotPreview(s)" class="draggable" [draggable]="true" (dragstart)="onDragStart($event, s)" style="z-index: 10;"></div>
                  }
                </div>
                @if(s.shotApprovalStateId === shotStatusEnum.Approved){
                  <div class="shot-icon approved">
                    <i class="fa fa-thumbs-up margin-small" title="Approve"></i>
                  </div>
                }
                @if(s.shotApprovalStateId === shotStatusEnum.Rejected){
                  <div class="shot-icon rejected">
                    <i class="fa fa-thumbs-down margin-small" title="Rejected"></i>
                  </div>
                }
              </div>
            </div>
          </div>      
        </div>

        @if(sortedImages[key]){
          <div class="card sorted-images-container">
             @for(s of sortedImages[key]; track s){
                <div class="margin-bottom uploaded-shot align-center">
                  <div class="flex justify-center margin-bottom-small">
                    <div class="thumbnail medium border"
                      [ngClass]="{'dragoverable': tmpShot && tmpShot.orderImageId === s.orderImageId }">
                      <div class="img-container">
                        <img [src]="s.imgPath">
                      </div>
                      <div class="draggable" [draggable]="true" (dragstart)="onDragStart($event, s)"></div>
                    </div>
                  </div>
                  <div class="flex center">
                    <div class="flex-0 margin-left-x-small">
                      <bt-menu [show]="s.showMenu" (hidden)="s.showMenu = false" (showed)="s.showMenu = true">
                        <div class="menu-item" (click)="onShowShotPreview(s)">
                          <i class="fa fa-eye"></i>Preview shot
                        </div>
                        <div class="menu-item warning" (click)="onDeleteUploadedShot(s)">
                          <i class="fa fa-trash"></i>Delete shot
                        </div>
                      </bt-menu>
                    </div>
                    <div [title]="s.fileName" class="flex-1 truncate">
                      {{s.fileName}}
                    </div>
                  </div>
                </div>
                }
          </div>
        }
        }
      </div>
      <div class="container-35 card">
        <bt-loader [loaderId]="uploadedShotsLoaderId">
          <div class="flex column custom-height">
            <div class="flex-0">
              <h4 class="margin-bottom">Uploaded shots</h4>
              <div class="margin-bottom">
                Upload all the pics you want, than simple drag and drop them in the correct slot
              </div>
            </div>
            <div class="flex-1 margin-bottom-small overflow">
              @for(s of uploadedShots; track s){
              <div class="margin-bottom uploaded-shot align-center">
                <div class="flex justify-center margin-bottom-small">
                  <div class="thumbnail medium border"
                    [ngClass]="{'dragoverable': tmpShot && tmpShot.orderImageId === s.orderImageId }">
                    <div class="img-container">
                      <img [src]="s.imgPath">
                    </div>
                    <div class="draggable" [draggable]="true" (dragstart)="onDragStart($event, s)"></div>
                  </div>
                </div>
                <div class="flex center">
                  <div class="flex-0 margin-left-x-small">
                    <bt-menu [show]="s.showMenu" (hidden)="s.showMenu = false" (showed)="s.showMenu = true">
                      <div class="menu-item" (click)="onShowShotPreview(s)">
                        <i class="fa fa-eye"></i>Preview shot
                      </div>
                      <div class="menu-item warning" (click)="onDeleteUploadedShot(s)">
                        <i class="fa fa-trash"></i>Delete shot
                      </div>
                    </bt-menu>
                  </div>
                  <div [title]="s.fileName" class="flex-1 truncate">
                    {{s.fileName}}
                  </div>
                </div>
              </div>
              }
            </div>
            <div 
              class="dropzone"
              (dragover)="onDropZoneDragOver($event)"
              (dragleave)="onDropZoneDragLeave($event)"
              (drop)="onDropZoneDrop($event)"
              [class.active]="dropzoneActive"
              style="border: 2px dashed #aaa; padding: 50px; text-align: center; margin-bottom: 10px;"
            >
              Trascina qui le foto da caricare
            </div>
            <div class="flex-0 flex justify-center">
              <input style="display: none" multiple type="file" (change)="onImagesUpload($event)" #selectImages>
              <button (click)="selectImages.click()">
                <i class="fa fa-upload"></i>
                Upload shots
              </button>
              <button (click)="sortImagesByColor()" style="margin-inline:5px" title="Auto Sorting">
                <i class="fa fa-rotate"></i>
              </button>
            </div>
          </div>
        </bt-loader>
      </div>
    </div>
  </ng-container>
  }
</bt-loader>

@if(inDragging && tmpShot){
<ng-container>
  <div class="background">
  </div>
  <div [id]="elementInDragId" class="drag-element card padding-x-small">
    <img class="full" [src]="tmpShot.imgPath">
  </div>
</ng-container>
}

@if(basicFile){
<bt-img-preview [file]="basicFile" (closed)="basicFile = null"></bt-img-preview>
}

@if(currentSidebarType === sidebarTypeEnum.orderComments){
<bt-sidebar sidebarTitle="Order comments" (exit)="currentSidebarType = null">
  <bt-sidebar-comments [orderId]="orderId"></bt-sidebar-comments>
</bt-sidebar>
}

@if(currentSidebarType === sidebarTypeEnum.shotsComments){
<bt-sidebar sidebarTitle="Shots comments" (exit)="currentSidebarType = null">
  <bt-sidebar-comments [style]="orderDetails.selected" [orderId]="orderId"></bt-sidebar-comments>
</bt-sidebar>
}

@if(currentSidebarType === sidebarTypeEnum.deleteAction){
<bt-sidebar sidebarTitle="Delete shot" (exit)="exitFromSidebar()">
  @if(tmpShot){
  <div class="flex overflow column">
    <div class="flex-0 padding-top-large padding-bottom-large">
      Are you sure you want to delete selected shot?
    </div>
    <div class="flex-1 padding-bottom-large flex center justify-center sidebar-img-container">
      <img [src]="tmpShot.imgPath">
    </div>
    <div class="flex-0">
      <button class="full-width warning" [loaderId]="sidebarLoaderId" (click)="deleteShot()">
        <i class="fa fa-trash"></i>
        Delete shot
      </button>
    </div>
  </div>
  }
</bt-sidebar>
}

@if(currentSidebarType === sidebarTypeEnum.customSidebar){
<bt-sidebar sidebarTitle="Assign shot" (exit)="exitFromSidebar()">
  @if(tmpShot){
  <div class="flex overflow column">
    <div class="flex-0 padding-top-large padding-bottom-large">
      Are you sure you want assign dragged shot as <b>{{overedData.shot.shotTypeName}}</b> for
      <b>{{overedData.style.fullName}}</b>?
    </div>
    <div class="flex-1 padding-bottom-large flex center justify-center sidebar-img-container">
      <img [src]="tmpShot.imgPath">
    </div>
    <div class="flex-0">
      @if (!this.tmpShot.orderImageId && this.tmpShot.hasOwnProperty('shotId')){
        <button class="full-width" style="margin-bottom: 0.5rem;" [loaderId]="sidebarLoaderId" (click)="assignShot(undefined, undefined, undefined, 1)">
          <i class="fa fa-check-circle"></i>
          Replace shot
        </button>
      }
      <button class="full-width" [loaderId]="sidebarLoaderId" (click)="assignShot()">
        <i class="fa fa-check-circle"></i>
        Assign shot
      </button>
    </div>
  </div>
  }
</bt-sidebar>
}